// DispatchMap.jsx
import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { Button } from '@mui/material';
import VirtualizedAutocomplete from '../../../../../../components/Dropdown/VirtualizedAutocomplete';

// Custom marker icon (optional - same style as RouteMapper)
const createCustomIcon = (color = '#007BFF') => {
    const svgIcon = `
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="41" viewBox="0 0 25 41">
            <path fill="${color}" d="M12.5 0C5.6 0 0 5.6 0 12.5c0 6.9 11.8 26.3 12.2 27L12.5 41l.3-1.5C13.2 38.8 25 19.4 25 12.5 25 5.6 19.4 0 12.5 0z"/>
            <circle cx="12.5" cy="12.5" r="5.5" fill="#FFF"/>
        </svg>
    `;
    return new L.DivIcon({
        html: svgIcon,
        className: 'custom-div-icon',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
    });
};


const transformData = (data) => {
    return data.map(entry => ({
        building: entry.building?.buildingReference || entry.building?.buildingSite || entry.building?.buildingAddressLine1 || entry.building?.buildingAddressLine2 || 'Unknown',
        ticket: entry?.ticket?.id,
        mechanic: entry?.assignedTo?.email || 'Unassigned',
        latitude: entry.building?.latitude,
        longitude: entry.building?.longitude,
    }));
}


const DispatchMap = ({ data, mechanics }) => {

    const [selectedMechanic, setSelectedMechanic] = useState(null);
    const [validMarkers, setValidMarkers] = useState([]);


    const center = [40.7831, -73.9712]; // NYC Center
    const nycBounds = [
        [40.45, -74.3], // SW corner slightly more west/south
        [40.95, -73.65] // NE corner slightly more east/north
    ];

    useEffect(() => {
        const transformedData = transformData(data.filter(entry => {
            const b = entry.building;
            const filter = selectedMechanic ? entry.assignedTo?.email === selectedMechanic?.email : true;
            return b && b.latitude && b.longitude && entry?.status !== "Completed" && filter;
        }));
        setValidMarkers(transformedData);
    }, [data, selectedMechanic]);

    return (
        <div className="p-6 flex-grow" style={{ height: '100vh' }}>

            <h2 className="text-2xl font-bold mb-4 border-b-2 border-gray-800 pb-1">
                Dispatch Map
            </h2>

            <div className="flex flex-col gap-4 items-center bg-gray-100 p-4 rounded-md">

                <div className="flex flex-row items-center justify-between w-full">
                    <VirtualizedAutocomplete
                        options={mechanics}
                        value={selectedMechanic || {}}
                        onChange={(e, newValue) => setSelectedMechanic(newValue)}
                        label="Filter By Mechanic"
                        optionKey="mechanicId"
                        optionLabel="email"
                    />


                    <Button
                        variant="contained"
                        style={{
                            backgroundColor: 'black',
                            color: 'white',
                            fontWeight: 'bold',
                            opacity: selectedMechanic ? 1 : 0.3,
                            marginLeft: '10%',
                        }}
                        onClick={() => setSelectedMechanic(null)}
                        className="ml-4"
                        disabled={!selectedMechanic}
                    >
                        X
                    </Button>

                </div>
            </div>

            <div className="mt-4 h-full w-full">
                <MapContainer center={center} zoom={12}
                    maxBounds={nycBounds}
                    maxBoundsViscosity={1.0}
                    minZoom={11}
                    maxZoom={16}
                    className='w-full h-full'

                    style={{
                        zIndex: 0,
                    }}


                >
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution="&copy; OpenStreetMap contributors"
                        className='z-[0]'
                    />
                    {validMarkers.map((entry, index) => {
                        const { building, ticket, mechanic, latitude, longitude } = entry;

                        return (
                            <Marker
                                key={index}
                                position={[latitude, longitude]}
                                icon={createCustomIcon()}
                            >
                                <Tooltip direction="top" offset={[0, -10]} opacity={1} permanent={false}>
                                    <div>
                                        <strong>Building Site:</strong> {building}<br />
                                        <strong>Mechanic:</strong> {mechanic}<br />
                                        <strong>Ticket:</strong> {ticket}
                                    </div>
                                </Tooltip>
                            </Marker>
                        );
                    })}
                </MapContainer>
            </div>
        </div>
    );
};




export default DispatchMap;